import { useContext } from 'react';
import { SiteContentContext } from '../context/SiteContentContext';
import { useSeo } from '../hooks/useSeo';
import '../styles/fleet_page.css';

const PrivacyPage = ({ isPreview = false }) => { // eslint-disable-line no-unused-vars
  useSeo({
    title: 'Политика конфиденциальности',
    description: 'Политика конфиденциальности парусной школы The Sailing Doctor.',
  });
  const { content } = useContext(SiteContentContext);

  return (
    <main className="fleet-page">
      <section className="fleet-page-hero">
        <h1>Политика конфиденциальности</h1>
      </section>
      <div className="privacy-body">
        {(content.privacyText || '').split('\n').map((line, i) => {
          if (!line.trim()) return <br key={i} />;
          const isHeading = /^\d+\./.test(line.trim()) || (line.trim() === line.trim().toUpperCase() && line.trim().length > 3);
          return isHeading
            ? <h2 key={i}>{line}</h2>
            : <p key={i}>{line}</p>;
        })}
      </div>
    </main>
  );
};

export default PrivacyPage;
